import { Stack, Text } from '@chakra-ui/react'

import type { UserDetails } from '@/components/Worlds/types'
import DiagonalAvatars from '@/components/Worlds/UI/Avatar/DiagonalAvatars'

export default function TutorLearnerBeingHelpedBanner({
  learner,
  tutor,
}: {
  learner: Pick<UserDetails, 'avatarUrl' | 'displayName' | 'id' | 'username'>
  tutor: Pick<UserDetails, 'avatarUrl' | 'displayName' | 'id' | 'username'>
}): JSX.Element {
  return (
    <Stack
      direction="column"
      width="100%"
      p="16px"
      bgColor="bg.subtle"
      borderRadius="8px"
      spacing="16px"
    >
      <Stack direction="row" alignItems="center" spacing="16px">
        <DiagonalAvatars userA={learner} userB={tutor} size="md" />
        <Text fontWeight={600}>{learner.displayName} is currently being helped by a tutor.</Text>
      </Stack>
    </Stack>
  )
}
